








































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
let viewer: any = ''
import ImageItem from './ImageItem.vue'
import VideoList from './videoList.vue'
import Task from '@/web-task'
import AudioPlayer from '@/views/AiiTasks/AudioPlayer.vue'
import { getStyleProperty, getSideMenuWidth } from '@/utils/util'
import RecordSection from '@/components/task/RecordSection.vue'
@Component({
	components: {
		ImageItem,
		VideoList,
		AudioPlayer,
		RecordSection,
	},
})
export default class ImageInfo extends Vue {
	@Prop()
	private supplyInfo!: string

	@Prop()
	private show!: any

	@Prop()
	private injured: any

	@Prop()
	private order: any

	@Prop()
	private boardImageList: any

	private imageInfo: any = ''
	private task: any = ''
	private isOtherInvestigate: boolean = false
	private audioList: any = []
	private videoType: any = ''
	@Watch('order', { immediate: true })
	private onOrderChange() {
		const task = new Task({
			propsData: {
				order: this.order,
				injured: this.injured,
				boardImageList: this.boardImageList,
				setting: this.$store.state.setting,
			},
		})
		this.task = task
		this.isOtherInvestigate = task.isOtherInvestigate
		if (task.isOtherInvestigate) {
			this.injured.fileList &&
				this.injured.fileList.forEach((item: any) => {
					if (item.fileType == 'audio') {
						this.audioList.push({
							picId: item.fileId,
							picName: item.fileName,
							picUrl: item.fileUrl,
							type: item.fileType,
							orderNum: item.orderNum,
						})
					}
				})
			this.videoType = '0000'
		}

		if (task.isInvestigate) {
			this.imageInfo = task.getInvestigateImageInfo()
		} else if (task.isOtherInvestigate) {
			this.imageInfo = task.getOtherInvestigateImageInfo()
		} else if (task.isMediate) {
			this.imageInfo = task.getMediateImageInfo()
		} else {
			this.imageInfo = task.getImageInfo()
		}
	}

	private get needPlaceholder() {
		return (
			this.order.orderStatus <= '03' ||
			(this.order.orderStatus >= '06' && this.order.orderStatus < '16')
		)
	}

	private get mediaInfoMap() {
		const obj: any = {}
		if (this.injured.mediaInfoList && this.injured.mediaInfoList.length) {
			for (const i of this.injured.mediaInfoList) {
				if (!obj[i.type]) {
					obj[i.type] = []
				}
				obj[i.type].push(i)
			}
		}
		this.boardImageList &&
			this.boardImageList.forEach((item: any, index: any) => {
				item.type = `${item.type}${index}`
			})
		if (this.boardImageList && this.boardImageList.length) {
			for (const i of this.boardImageList) {
				if (!obj[i.type]) {
					obj[i.type] = []
				}
				obj[i.type].push(i)
			}
		}

		return obj
	}

	// 分散在各对象中的mediaInfo
	private get separateMediaMap() {
		const obj: any = {}
		if (this.injured.owner && this.injured.owner.mediaInfoList) {
			this.setMediaInfoMap(obj, 'owner', this.injured.owner.mediaInfoList)
		}
		if (this.injured.injuredList && this.injured.injuredList.length) {
			this.injured.injuredList.forEach((singleInjured: any, index: number) => {
				this.setMediaInfoMap(
					obj,
					`injuredList${index}`,
					singleInjured.mediaInfoList
				)
			})
		}
		return obj
	}

	private setMediaInfoMap(target: any, key: string, source: any) {
		target[key] = {}
		if (source && source.length) {
			for (const i of source) {
				if (!target[key][i.type]) {
					target[key][i.type] = []
				}
				target[key][i.type].push(i)
			}
		}
	}

	private getSignName(survey: any) {
		if (survey) {
			return survey.sign === '0' ? '拒绝签字' : survey.intervieweeName
		}
		return ''
	}

	private getURL(url: any) {
		if (url) {
			return url + '?imageMogr2/thumbnail/192x'
		} else {
			return ''
		}
	}
	private openReport(data: any) {
		const FileExt = data.fileName.replace(/.+\./, '')
		const isPDF = ['pdf'].indexOf(FileExt.toLowerCase()) !== -1
		if (isPDF) {
			window.open(data.fileUrl + '?disposition=inline')
		} else {
			window.open(
				`http://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
					data.fileUrl.trim()
				)}`
			)
		}
	}
	private setPlayerPos() {
		// 设置播放组件在右侧页面区域（对应左侧菜单栏）水平居中
		this.$nextTick(() => {
			let playerEl: any = this.$refs.audioWrapper
			if (playerEl) {
				let width = parseInt(getSideMenuWidth() || 0)
				let rightContentWidth = parseInt(
					getStyleProperty(
						document.querySelector('.ant-layout-content'),
						'width'
					) || 0
				)
				playerEl.style.left = `${width + rightContentWidth / 2}px`
			}
		})
	}
	@Watch('mediaInfoMap', { immediate: true })
	private onMapChange() {
		if (!this.injured.mediaInfoList) {
			return
		}
		this.$nextTick(() => {
			const wrapper2 = document.querySelector('#images')
			const options: any = {
				title(image: any) {
					return image.alt
				},
				url(image: any) {
					return image.src.replace(/\?imageMogr2\S+/, '')
				},
				toolbar: {
					oneToOne: {
						size: 'large',
					},
					reset: {
						size: 'large',
					},
					prev: {
						size: 'large',
					},
					play: {
						size: 'large',
					},
					next: {
						size: 'large',
					},
					rotateLeft: {
						size: 'large',
					},
					rotateRight: {
						size: 'large',
					},
				},
			}
			viewer && viewer.destroy()
			const wrapper: any = document.querySelector('#images')
			viewer = new Viewer(wrapper, options)
		})
	}
}
